module.exports = __webpack_public_path__ + "static/icons/icon-reef--green-47b9591c7acbcbae9973ccc9c0fbd86b.svg";